var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "item-card",
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
        "background-color": "rgb(250, 251, 252)",
      },
      attrs: { shadow: "never", "body-style": "margin: 0px;" },
    },
    [
      _c(
        "div",
        {
          staticClass: "item-names",
          staticStyle: { margin: "8px 24px 24px 8px" },
        },
        [_c("p", [_vm._v("No shipping info available yet")])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }